import { useState, useEffect, useRef } from "react";

import './GeneralTour.css';

import Img from "Img";

import { GetDataPage } from "interface/Data";

export default function Page_GeneralTour(props){

    const [ dataPage, setDataPage ] = useState(GetDataPage('general_tour'));

    const [ position, setPosition ]       = useState(0);
    const [ smooth, setSmooth ]           = useState(0);
    const [ oldPosition, setOldPosition ] = useState(0);
    
    const [ listImg, setListImg ] = useState([]);

    const [ startPosition, setStartPosition ] = useState(false);
    let speed   = 0;
    let time    = 0;
    let elapsed = 0;

    function LoadImg(){
        let count = 0;
        const newDate = [];
        dataPage[0].list_img.map((elem, index)=>{
            fetch(props.folder + "general_tour/" + dataPage[0].code + "/mobile/" + elem.img).then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
                const reader   = new FileReader();
                reader.onload  = ()=>{
                    count++;
                    newDate[index] = { "id": index, "url": reader.result };

                    if(dataPage[0].list_img.length == count){
                        setListImg([...newDate]);

                        props.setLoading(false);
                    }
                }
                reader.onerror = reject
                reader.readAsDataURL(blob)
            }))
        });
    }

    function AltMovieAnimation(){
        const now = Date.now();
        const deltaTime = (now - time) / 1000;
        elapsed += deltaTime;
        time = now;

        let delta = elapsed * speed;
        if(delta >= 1){
            setSmooth(position);
            setOldPosition(position);
        }else {
            setSmooth(Math.round(lerp(oldPosition, position, delta)));
            window.requestAnimationFrame(AltMovieAnimation);
        }
    }

    function AltSmoothStart(){
        speed = (1 - (Math.abs(position - oldPosition) / (dataPage[0].list_img.length - 1))) * 10;        
        elapsed = 0;
        time    = Date.now();
        AltMovieAnimation();
    }

    function lerp (start, end, amt){
        return (1-amt) * start + amt * end;
    }

    useEffect(()=>{
        props.setLoading(true);
        
        setTimeout(() => {
            setStartPosition(true);
        }, 1000);        

        LoadImg();
    }, []);

    useEffect(()=>{
        if(startPosition == true){
            AltSmoothStart()
        }
    }, [position]);

    return(
        <div className="Page_GeneralTour">
            <div className="img_sun">
                {
                    listImg.map((elem, index)=>{
                        return(
                            <Img listImg={ elem.url } showImg={ index == smooth ? true : false } key={ index } />
                        )
                    })
                }
            </div>

            <div className="btn">
                <div className="line_position_sun" onClick={ ()=>{ } }>
                    <input type="range" className="input_range" min="0" max={ (dataPage[0].list_img.length - 1) } step={ 1 } onChange={ (e)=>{ setPosition(e.target.value) } } value={ position } />
                </div>
            </div>
        </div>
    )
}